module.exports = __webpack_public_path__ + "img/2025-12-20e_1.c5b08594.jpg";